import { SvgIcon, SvgIconProps } from '@mui/material';

const EmailCampaignIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props}>
      <svg xmlns='http://www.w3.org/2000/svg' width='24' height='20' viewBox='0 0 24 20' fill='none'>
        <g clipPath='url(#clip0_901_8965)'>
          <path
            d='M2.38989 9.55V3.4C2.38989 2.76 2.63989 2.15 3.06989 1.7C3.49989 1.25 4.08989 1 4.69989 1H20.0799C20.6899 1 21.2799 1.25 21.7099 1.7C22.1499 2.15 22.3899 2.76 22.3899 3.4M22.3899 3.4V15.76C22.3899 16.46 22.1499 17.14 21.7099 17.63C21.2799 18.13 20.6899 18.41 20.0799 18.41H10.6599M22.3899 3.4V3.66C22.3899 4.07 22.2899 4.47 22.0999 4.83C21.9099 5.19 21.6299 5.49 21.2999 5.7L13.6099 10.62C13.2499 10.85 12.8299 10.98 12.3999 10.98C11.9699 10.98 11.5499 10.86 11.1899 10.62L3.48989 5.7C3.14989 5.49 2.87989 5.18 2.68989 4.83C2.49989 4.47 2.39989 4.07 2.39989 3.66V3.4'
            stroke='currentColor'
            strokeWidth='1.5'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M1.13989 13.2002H5.19989'
            stroke='currentColor'
            strokeWidth='1.5'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M1.13989 16.1899H7.11989'
            stroke='currentColor'
            strokeWidth='1.5'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
        </g>
        <defs>
          <clipPath id='clip0_901_8965'>
            <rect width='23.39' height='19.46' fill='white' />
          </clipPath>
        </defs>
      </svg>
    </SvgIcon>
  );
};

export default EmailCampaignIcon;
